import React from "react";
import {
    Camera, CheckCircle2, FileText, History as HistoryIcon,
    PackageCheck, Play, Send, Wrench,
} from "lucide-react";
import { formatDateTime } from "@/lib/utils";

const ACTION_META = {
    sent_to_workshop: { icon: Send, label: "Equipamento enviado para oficina", color: "text-slate-600" },
    received: { icon: PackageCheck, label: "Equipamento recebido", color: "text-yellow-600" },
    diagnosis_started: { icon: Play, label: "Diagnóstico iniciado", color: "text-orange-600" },
    diagnosis_updated: { icon: FileText, label: "Diagnóstico atualizado", color: "text-muted-foreground" },
    report_updated: { icon: FileText, label: "Laudo técnico atualizado", color: "text-muted-foreground" },
    service_added: { icon: Wrench, label: "Serviço adicionado", color: "text-muted-foreground" },
    service_removed: { icon: Wrench, label: "Serviço removido", color: "text-muted-foreground" },
    part_added: { icon: Wrench, label: "Peça adicionada", color: "text-muted-foreground" },
    part_removed: { icon: Wrench, label: "Peça removida", color: "text-muted-foreground" },
    photo_added: { icon: Camera, label: "Foto adicionada", color: "text-muted-foreground" },
    photo_removed: { icon: Camera, label: "Foto removida", color: "text-muted-foreground" },
    checklist_updated: { icon: CheckCircle2, label: "Checklist atualizado", color: "text-muted-foreground" },
    diagnosis_finished: { icon: CheckCircle2, label: "Diagnóstico finalizado", color: "text-indigo-600" },
};

export function WorkshopTimeline({ workshop }) {
    const events = [...(workshop?.history || [])].sort(
        (a, b) => new Date(b.at).getTime() - new Date(a.at).getTime(),
    );
    if (events.length === 0) {
        return (
            <div className="rounded-md border border-dashed p-6 text-center text-xs text-muted-foreground">
                <HistoryIcon className="mx-auto mb-2 h-6 w-6 opacity-60" />
                Sem eventos ainda.
            </div>
        );
    }
    return (
        <ol className="relative border-l pl-6" data-testid="workshop-timeline">
            {events.map((ev, i) => {
                const meta = ACTION_META[ev.action] || {
                    icon: HistoryIcon, label: ev.action, color: "text-muted-foreground",
                };
                const Icon = meta.icon;
                return (
                    <li key={`${ev.at || "no-date"}-${ev.action || "action"}-${i}`} className="mb-4 last:mb-0">
                        <div className={`absolute -left-3 grid h-6 w-6 place-items-center rounded-full border bg-background ${meta.color}`}>
                            <Icon className="h-3 w-3" />
                        </div>
                        <div className="text-sm font-medium">{meta.label}</div>
                        {ev.note && <div className="text-xs text-muted-foreground">{ev.note}</div>}
                        <div className="mt-0.5 text-[11px] text-muted-foreground">
                            {ev.at ? formatDateTime(ev.at) : ""}
                        </div>
                    </li>
                );
            })}
        </ol>
    );
}

export default WorkshopTimeline;
